<div class="button-bar">
    <app-button iconName="camera" tooltip="Commencer une captation en streaming" (clickEvent)="openVideoRecording()"></app-button>
    <app-button iconName="file-import" tooltip="Ajouter un fichier" (clickEvent)="uploadFile()"></app-button>
</div>
<div [style.display]="inputVideoUrl ? 'block' : 'none'">
    <div class="button-bar justify-content-start">
        <app-button iconName="camera" (clickEvent)="captureImage()"></app-button>
        <app-button (clickEvent)="videoPlayer.play()" fill="solid" iconName="player-play-filled" *ngIf="videoPlayer.paused"></app-button>
        <app-button (clickEvent)="videoPlayer.pause()" fill="solid" iconName="player-pause-filled" *ngIf="!videoPlayer.paused"></app-button>
        <app-button (clickEvent)="onChangePlaybackRate(playRate)" [fill]="formGroup.get('playbackRate').value === playRate ? 'solid' : 'clear'" *ngFor="let playRate of playBackRates" [label]="(playRate * 100) + '%'"></app-button>
        <app-button iconName="arrows-maximize" (clickEvent)="maximized = !maximized"></app-button>
    <app-button *ngIf="inputVideoUrl" iconName="download" tooltip="Télécharger" (clickEvent)="download()"></app-button>
        {{videoPlayer?.currentTime | number : '1.0-2'}} sec
    </div>
    <video [style.max-width.%]="maximized ? '100' : '70'" #videoPlayer [src]="inputVideoUrl" controls></video>

</div>
<h3 *ngIf="pictures?.length > 0">Images capturées</h3>
<div class="d-flex gap-5">
    <div (click)="editPicture(picture)" *ngFor="let picture of pictures" class="d-block text-center cursor-pointer">
        <img [src]="picture.mergedImageUrl ? picture.mergedImageUrl : picture.backgroundImageUrl" style="max-width: 150px;"/>
        <div>{{picture.time | number : '1.0-2'}} sec
        <span class="cursor-pointer" (click)="removePicture(picture)">Retirer</span>
        </div>
    </div>
</div>